export function setupSalesmartly(item) {
  const getSaleSmartlyApi = () => {
    if (window.ssq && typeof window.ssq.push === 'function') {
      return window.ssq
    }
    ;(function (d, s, id, w, n) {
      w.__ssc = w.__ssc || {}
      w.__ssc.license = item.id
      w.__ssc.setting = { hideIcon: true }
      if (w.ssq) return
      n = w.ssq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      n.push = n
      n.loaded = !0
      n.queue = []
      const sjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      const js = d.createElement(s)
      js.id = id
      js.src = 'https://assets.salesmartly.com/chat/widget/code/install.js'
      sjs.parentNode.insertBefore(js, sjs)
    })(document, 'script', 'ss-chat', window)
    return window.ssq
  }

  const SALESMARTLY_API = getSaleSmartlyApi()
  if (!SALESMARTLY_API || typeof SALESMARTLY_API.push !== 'function') {
    console.warn('[Customer Service] SaleSmartly API 初始化失敗')
    return null
  }

  let loaded = false
  const pending = []

  const saleSmartlyCall = (action, param) => {
    if (loaded) {
      SALESMARTLY_API.push(action, param)
    } else {
      pending.push([action, param])
    }
  }

  SALESMARTLY_API.push('onReady', () => {
    loaded = true
    console.log('[Customer Service] SaleSmartly Ready')
    while (pending.length) {
      const [action, param] = pending.shift()
      SALESMARTLY_API.push(action, param)
    }
  })

  return {
    maximize() {
      try {
        saleSmartlyCall('chatOpen')
      } catch (error) {
        console.log('SaleSmartly not ready yet')
      }
    },
    minimize() {
      try {
        saleSmartlyCall('chatClose')
      } catch (error) {
        console.log('SaleSmartly not ready yet')
      }
    },
    hide() {
      try {
        saleSmartlyCall('chatClose')
      } catch (error) {
        console.log('SaleSmartly not ready yet')
      }
    },
    setUser(uidSite) {
      saleSmartlyCall('setLoginInfo', {
        user_id: uidSite,
        user_name: uidSite,
      })
    },
  }
}
